import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";

function SendNotificationDashboard() {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [status, setStatus] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const pageSize = 10;

  const fetchUsers = async (pageNumber) => {
    try {
      const res = await axios.get(
        `https://api.herracim.az/api/dashboard/user-dashboard?page=${pageNumber}&pageSize=${pageSize}`,
        { withCredentials: true }
      );
      const newOptions = res.data.users.map((user) => ({
        label: `${user.fullName} (${user.email})`,
        value: user.id,
      }));

      setOptions((prev) => [...prev, ...newOptions]);

      if (res.data.users.length < pageSize) {
        setHasMore(false);
      }
    } catch (err) {
      console.error("İstifadəçilər yüklənə bilmədi:", err);
    }
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  useEffect(() => {
    const delay = setTimeout(async () => {
      if (!inputValue) {
        setIsSearching(false);
        return;
      }

      setIsSearching(true);
      try {
        const res = await axios.get(`https://api.herracim.az/api/dashboard/search?query=${inputValue}`, {
          withCredentials: true,
        });

        const searchResults = res.data.map((user) => ({
          label: `${user.fullName} (${user.email})`,
          value: user.id,
        }));

        setOptions(searchResults);
        setHasMore(false);
      } catch (err) {
        console.error("Axtarış zamanı xəta:", err);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [inputValue]);

  const handleMenuScrollToBottom = () => {
    if (hasMore && !isSearching) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchUsers(nextPage);
    }
  };

  const handleSelectAll = () => {
    setSelectAll(true);
    setSelectedUsers([]);
  };

  const handleUnselectAll = () => {
    setSelectAll(false);
    setSelectedUsers([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    try {
      if (selectAll) {
        await axios.post(
          "https://api.herracim.az/api/dashboard/send-to-all",
          { title, message },
          { withCredentials: true }
        );
      } else if (selectedUsers.length > 0) {
        for (let user of selectedUsers) {
          await axios.post(
            "https://api.herracim.az/api/dashboard/send-to-user",
            {
              title,
              message,
              userId: user.value,
              
            },
            { withCredentials: true }
          );
        }
      } else {
        setStatus("error");
        return;
      }

      setStatus("success");
      setTitle("");
      setMessage("");
      setSelectedUsers([]);
      setSelectAll(false);
      setPage(1);
      setOptions([]);
      fetchUsers(1);
    } catch (err) {
      console.error("Göndərmə zamanı xəta:", err);
      setStatus("error");
    }
  };

  return (
    <div className="admin-notification-container">
      <h2>Bildiriş Göndər</h2>
      <form className="notification-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Başlıq"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <textarea
          placeholder="Mesaj mətni"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center", marginBottom: "10px", width: "100%" }}>
          <div style={{ flex: 1, minWidth: "300px" }}>
            <Select
              options={options}
              value={
                selectAll
                  ? [{ label: "✅ Hamısı seçildi", value: "all" }]
                  : selectedUsers
              }
              isDisabled={selectAll}
              onMenuScrollToBottom={handleMenuScrollToBottom}
              onInputChange={(val, actionMeta) => {
                if (actionMeta.action === "input-change") {
                  setInputValue(val);
                } else if (actionMeta.action === "input-blur") {
                  setInputValue("");
                }
              }}
              onChange={(val) => {
                setSelectedUsers(val);
                setSelectAll(false);
              }}
              isMulti
              isClearable
              placeholder="İstifadəçiləri seçin və ya axtarın..."
              noOptionsMessage={() => "İstifadəçi tapılmadı"}
            />
          </div>

          {!selectAll ? (
            <button type="button" onClick={handleSelectAll}>
              🔘 Hamısını seç
            </button>
          ) : (
            <button type="button" onClick={handleUnselectAll}>
              ❌ Seçimi ləğv et
            </button>
          )}
        </div>

        <button type="submit">Göndər</button>

        {status === "success" && (
          <p className="success-message">✅ Bildiriş uğurla göndərildi</p>
        )}
        {status === "error" && (
          <p className="error-message">❌ Xəta baş verdi</p>
        )}
      </form>
    </div>
  );
}

export default SendNotificationDashboard;
